import Sidebar from "./Sidebar";
import UserMenu from "./UserMenu";
import NotificationBell from "./NotificationBell";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import GlobalSearchBar from "../GlobalSearchBar";
import MigrationModeBanner from "../MigrationModeBanner";
import SuperAdminOverrideBanner from "../SuperAdminOverrideBanner";
import { useAuth } from "../../contexts/AuthContext";

// Frontend chokepoint mirroring the backend's DATA_USER / LOGO_USER
// allowlist (`auth.get_current_user`). Both roles are permitted only
// inside the Data Hub surfaces:
//   /data/**            — Company Repository, Coverage, Logo Enrichment
//   /admin/verification — Verification Console
//   /admin/import       — Iter 47 Import wizard
//   /profile            — Profile page is always reachable
// Hitting any other path redirects to the Data landing rather than
// rendering an empty page on top of a backend 403.
const isRepositoryPath = (pathname) =>
    pathname.startsWith("/data") ||
    pathname.startsWith("/admin/verification") ||
    pathname.startsWith("/admin/import") ||
    pathname.startsWith("/profile");

export const AppLayout = () => {
    const { user, loading } = useAuth();
    const { pathname } = useLocation();

    // Iter 70 — LOGO_USER subjected to the same chokepoint as DATA_USER.
    const restrictedRole = user?.role === "data_user" || user?.role === "logo_user";
    if (!loading && restrictedRole && !isRepositoryPath(pathname)) {
        return <Navigate to="/data/companies" replace />;
    }

    return (
        <div className="min-h-screen flex bg-slate-50 text-slate-900" data-testid="app-layout">
            <Sidebar />
            <main className="flex-1 min-w-0 flex flex-col">
                <MigrationModeBanner />
                <SuperAdminOverrideBanner />
                {/* Iter 102.3 · Phase B — Header now hosts the top-right
                    UserMenu (EDDR-002). Sidebar footer no longer carries
                    profile/identity/sign-out. */}
                <header
                    className="sticky top-0 z-30 h-14 bg-white/95 backdrop-blur border-b border-slate-200 px-6 sm:px-8 flex items-center gap-4"
                    data-testid="app-header"
                >
                    <div className="flex-1 min-w-0">
                        <GlobalSearchBar />
                    </div>
                    <div className="shrink-0 flex items-center gap-2" data-testid="app-header-usermenu-slot">
                        {!restrictedRole && <NotificationBell />}
                        <UserMenu />
                    </div>
                </header>
                <div className="flex-1 min-w-0">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default AppLayout;
